export const baseUrl = "https://dota-api.binray.io"
// export const baseUrl = "http://localhost:3001"